<template>
  <div class="shopListPage">
    <div class="container">
      <Head @change="headChange" />
      <Condition @change="conditionChange" />
      <ProductList :param="params"></ProductList>
    </div>
    <BackTop />
    <div v-show="isShowLoad" class="loadBox">
      <van-loading size="30px" vertical color="#fff"><span style="color:#fff">加载中...</span> </van-loading>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import BackTop from '@/components/common/BackTop.vue'
import Head from '@/components/shop/Head'
import Condition from '@/components/shop/Condition'
import ProductList from '@/components/shop/productList'
import { getSession } from '@/util'
export default {
  name: 'shopList',
  components: {
    Head,
    Condition,
    ProductList,
    BackTop
  },
  setup() {
    let store = useStore()
    let { loyaltyDealerInfo: dealer } = store.state
    const state = reactive({
      shopList: getSession('shopList') || [],
      noData: false,
      isShowLoad: false,
      carInfo: {},
      condition: { dealer }
    })
    const headChange = data => {
      state.carInfo = data
    }
    const conditionChange = data => {
      state.condition = data
    }
    const params = computed(() => ({ carInfo: state.carInfo, ...state.condition }))

    onMounted(async () => {
      store.dispatch('getMyDdefaultCar')
    })
    return {
      ...toRefs(state),
      headChange,
      conditionChange,
      params
    }
  }
}
</script>

<style lang="scss" scoped>
.shopListPage {
  background-color: #f5f5f5;
}
.container {
  width: 100vw;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 60px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 60px);
}
.loadBox {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  padding-top: 250px;
  background-color: rgba($color: #000000, $alpha: 0.4);
}
</style>
